module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-cloud-84a49961691cc6b972ff2ee0c72a6bbf.svg";